import React from "react";
import { connect } from "react-redux";
import { Col, Badge } from "react-bootstrap";
import PropTypes from "prop-types";

import Table from "../../../layout/table";
import ConditionalButton from "../../../layout/conditional-button";

import { send as pageInfo, loading } from "../../../actions/page";
import { get as getConfigurations } from "../../../actions/email.configuration";
import { get as getSetting } from "../../../actions/settings";
import { withNavigation } from "../../../utils/wrapper";

class Settings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            size: 10,
            search: "",
            order: "email",
            index: 0,
            direction: "DESC",
            data: [],
            pages: 0,
            archived: 0,
            converted: 0,
            configs: [],      // initialize
            system: ""        // initialize
        };

        this.props.loading(true);
        this.props.pageInfo({ title: "Email Settings", breadcrumb: "Profiles" });
    }

    get headers() {
        return [
            {
                header: "Caption",
                sortable: false,
                source: "name",
                className: "text-muted text-small text-uppercase w-25",
                onRender: this.onNameLinkFormat // keep consistent with other columns
            },
            {
                header: "Host",
                sortable: false,
                source: "host",
                className: "text-muted text-small text-uppercase w-60",
                onRender: this.onLinkFormat
            },
            {
                header: "Port",
                sortable: true,
                source: "port",
                className: "text-muted text-small text-uppercase w-15",
                onRender: this.onLinkFormat
            }
        ];
    }

    onLinkFormat = (value, row) => {
        return (
            <a href={`/dashboard/settings/email/${row?.uuid}`}>
                {value}
            </a>
        );
    };

    onNameLinkFormat = (value, row) => {
        const isDefault = row?.name === this.state.system;
        return (
            <a href={`/dashboard/settings/email/${row?.uuid}`}>
                {value}{" "}
                {isDefault ? <Badge pill bg="dark">Default</Badge> : null}
            </a>
        );
    };

    loadData = async () => {
        this.props.loading(true);
        try {
            const configs = await this.props.getConfigurations();
            const system = await this.props.getSetting({ name: "FERA_EMAIL_CONFIGURATION" });

            this.setState({
                configs: Array.isArray(configs) ? configs : [],
                system: system?.value || ""
            });
        } finally {
            this.props.loading(false);
        }
    };

    componentDidMount = () => {
        // keeping your timing behavior, though direct call is usually fine
        setTimeout(async () => {
            await this.loadData();
        }, 30);
    };

    onNewClick = () => {
        this.props.navigate("add");
    };

    render() {
        return (
            <>
                <Col md="8" className="float-right text-end">
                    <ConditionalButton
                        enabledVariant="outline-primary"
                        tooltip="Create new email configuration"
                        display
                        enabled={true}
                        onEnabledClick={this.onNewClick}
                        icon="flash"
                    >
                        New
                    </ConditionalButton>
                </Col>

                <Col xs="12">
                    <Table
                        headers={this.headers}
                        page={this.state.configs || []}
                        size={this.state.size}
                        index={0}
                        pages={1}
                        searchable={false}
                        sizable={false}
                        sortable={false}
                    />
                </Col>
            </>
        );
    }
}

Settings.propTypes = {
    auth: PropTypes.object.isRequired,
    pageInfo: PropTypes.func.isRequired,
    loading: PropTypes.func.isRequired,
    getConfigurations: PropTypes.func.isRequired,
    getSetting: PropTypes.func.isRequired,
    navigate: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default withNavigation(
    connect(mapStateToProps, { pageInfo, loading, getConfigurations, getSetting })(Settings)
);
